import Dialog from '@mui/material/Dialog';
import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import FormInputText from '../common/Forms/FormTextField';
import InputDropdown from '../common/Forms/InputDropdown';
import FormInputMultiCheckbox from '../common/Forms/FormCheckbox';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { participant } from '../../redux/participant/participantSlice';
import {
  formDateFormat,
  PARTICIPANT_URL,
  fieldRequired,
  yesNoDropdown,
  mfDropdown,
  paperProps2,
} from '../../constants';
import moment from 'moment';
import {
  setArsonist,
  setDateOfBirth,
  setDeployedCombatDuty,
  setDiagnosedPostTraumaticStressDisorder,
  setEthnicityOrRace,
  setFirstName,
  setGender,
  setLastName,
  setMiddleName,
  setRegistration290,
  setSSN,
  setSuffix,
  setVeteran,
} from '../../redux/participant/AddParticipant/addParticipantSliceForm';
import { postStopApi, setStopApi } from '../../services/StopApi/StopApi';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  getBackdrop,
  getDialogHeading,
  getFormSuccess,
  getSaveCancel,
} from '../common/commonUtils/commonUtils';

const schema = yup.object().shape({
  dateOfBirth: yup
    .string()
    //.typeError('You must be at least 18 years old.')
    //.max(
    //  new Date(Date.now() - 567648000000),
    //  'You must be at least 18 years old.'
    //)
    .nullable(),
    //.required(),
  firstName: yup.string().required(fieldRequired),
  middleName: yup.string(),
  lastName: yup.string().required(fieldRequired),
  suffix: yup.string(),
  gender: yup.string().required(fieldRequired),
  ethnicityOrRace: yup.string(),
  veteran: yup.string().nullable(),
  deployedCombatDuty: yup.string().nullable(),
  diagnosedPostTraumaticStressDisorder: yup.string().nullable(),
  SSN: yup
    .string()
    //.required(fieldRequired)
    //.min(9, 'Must be exactly 9 numbers')
    //.max(9, 'Must be exactly 9 characters'),
});

const ParticipantDialog = (props) => {
  const dispatch = useDispatch();
  const { open, setOpen, fetchData, authToken, openBackdrop } = props;
  const [formSuccess, setFormSuccess] = useState(false);
  const [isAddParticipant, setIsAddParticipant] = useState(false);
  const addParticipantReferenceData = useSelector(
    (state) => state.AddParticipantReferenceData
  );
  const addParticipantSlice = useSelector(
    (state) => state.AddParticipantFormSlice
  );
  const todayDate = new Date();
  todayDate.setFullYear(todayDate.getFullYear() - 18);
  const dateString = todayDate.toISOString().split('T')[0];

  const defaultValue = {
    id: addParticipantSlice?.id,
    key: addParticipantSlice?.key ?? '',
    lastName: addParticipantSlice?.lastName ?? '',
    firstName: addParticipantSlice?.firstName,
    middleName: addParticipantSlice?.middleName ?? '',
    SSN: addParticipantSlice?.SSN ?? '',
    dateOfBirth: moment(addParticipantSlice?.dateOfBirth)
      .format(formDateFormat)
      .split('T')[0],
    suffix: addParticipantSlice?.suffix ?? '',
    gender: addParticipantSlice?.gender ?? '',
    ethnicityOrRace: addParticipantSlice?.ethnicityOrRace
      ? addParticipantSlice?.ethnicityOrRace
      : '',
    veteran: addParticipantSlice?.veteran ?? '',
    deployedCombatDuty: addParticipantSlice?.deployedCombatDuty ?? '',
    diagnosedPostTraumaticStressDisorder:
      addParticipantSlice?.diagnosedPostTraumaticStressDisorder ?? '',
    registration290: addParticipantSlice?.registration290 ?? false,
    arsonist: addParticipantSlice?.arsonist ?? false,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
  });
  const { handleSubmit, reset, control, setValue, watch, register, formState } =
    useFunction;

  const { isValid, dirtyFields, errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.key,
    defaultValue.lastName,
    defaultValue.firstName,
    defaultValue.middleName,
    defaultValue.SSN,
    defaultValue.dateOfBirth,
    defaultValue.suffix,
    defaultValue.gender,
    defaultValue.ethnicityOrRace,
    defaultValue.veteran,
    defaultValue.deployedCombatDuty,
    defaultValue.diagnosedPostTraumaticStressDisorder,
    defaultValue.registration290,
    defaultValue.arsonist,
  ]);

  const handleClose = () => {
    setOpen(false);
    reset(defaultValue);
  };

  const onSubmit = () => {
    const url = `${PARTICIPANT_URL}`;
    const authorization = authToken;
    if (addParticipantSlice?.newLoadedData === true) {
      const payload = {
        firstName: addParticipantSlice?.firstName
          ? addParticipantSlice?.firstName
          : null,
        middle: addParticipantSlice?.middleName
          ? addParticipantSlice?.middleName
          : null,
        lastName: addParticipantSlice?.lastName
          ? addParticipantSlice?.lastName
          : null,
        suffix: addParticipantSlice?.suffix
          ? addParticipantSlice?.suffix
          : null,
        SSN: addParticipantSlice?.SSN ? addParticipantSlice?.SSN : null,
        dateOfBirth: addParticipantSlice?.dateOfBirth
          ? addParticipantSlice?.dateOfBirth
          : null,
        gender: addParticipantSlice?.gender
          ? addParticipantSlice?.gender
          : null,
        ethnicityOrRace: addParticipantSlice?.ethnicityOrRace
          ? addParticipantSlice?.ethnicityOrRace
          : null,
        veteran: addParticipantSlice?.veteran
          ? addParticipantSlice?.veteran
          : null,
        deployedCombatDuty: addParticipantSlice?.deployedCombatDuty
          ? addParticipantSlice?.deployedCombatDuty
          : null,
        diagnosedPostTraumaticStressDisorder:
          addParticipantSlice?.diagnosedPostTraumaticStressDisorder
            ? addParticipantSlice?.diagnosedPostTraumaticStressDisorder
            : null,
        registration290:
          addParticipantSlice?.registration290 === ''
            ? null
            : addParticipantSlice?.registration290,
        arsonist:
          addParticipantSlice?.arsonist === ''
            ? null
            : addParticipantSlice?.arsonist,
      };
      postStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          fetchData();
          setFormSuccess(true);
          setIsAddParticipant(true);
        }
      }).catch((e) => alert(e));
    } else {
      const payload = {
        id: addParticipantSlice?.id,
        firstName: addParticipantSlice?.firstName,
        middle: addParticipantSlice?.middleName,
        lastName: addParticipantSlice?.lastName,
        suffix: addParticipantSlice?.suffix,
        SSN: addParticipantSlice?.SSN,
        dateOfBirth: addParticipantSlice?.dateOfBirth,
        gender: addParticipantSlice?.gender,
        ethnicityOrRace: addParticipantSlice?.ethnicityOrRace,
        veteran: addParticipantSlice?.veteran,
        deployedCombatDuty: addParticipantSlice?.deployedCombatDuty,
        diagnosedPostTraumaticStressDisorder: addParticipantSlice?.diagnosedPostTraumaticStressDisorder,
        registration290: addParticipantSlice?.registration290,
        arsonist: addParticipantSlice?.arsonist,
      };
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          const participantDetail = [
            {
              key: payload.lastName + ', ' + payload.firstName,
              id: addParticipantSlice?.id,
              lastName: payload.lastName,
              firstName: payload.firstName,
              middleName: payload.middle,
              ssn: payload.SSN,
              suffix: payload.suffix,
              gender: payload.gender,
              ethnicityOrRace: payload.ethnicityOrRace,
              veteran: payload.veteran,
              deployedCombatDuty: payload.deployedCombatDuty,
              diagnosedPostTraumaticStressDisorder:
                payload.diagnosedPostTraumaticStressDisorder,
              arsonist: payload.arsonist,
              dateOfBirth: payload.dateOfBirth,
              registration290: payload.registration290,
              //inactive: rowData.inactive,
            },
          ];
          dispatch(participant(participantDetail));
          fetchData();

          setFormSuccess(true);
        }
      }).catch((e) => alert(e));
    }
    setOpen(false);
  };

  return (
    <>
      <Dialog open={open} PaperProps={paperProps2}>
        {openBackdrop ? (
          getBackdrop(openBackdrop)
        ) : (
          <>
            {getDialogHeading('Participant Id', defaultValue?.id, handleClose)}
            <Grid container spacing={2} style={{ padding: '10px 30px' }}>
              <Grid item xs={12} sm={6}>
                {addParticipantSlice?.newLoadedData === true ? (
                  <></>
                ) : (
                  <FormInputText
                    name='key'
                    control={control}
                    label='Participant Key'
                    disabled={true}
                  />
                )}
                <FormInputText
                  name='firstName'
                  control={control}
                  label='First Name'
                  errors={!!errors.firstName}
                  helperText={errors?.firstName?.message}
                  register={register('firstName', {
                    onChange: (e) => dispatch(setFirstName(e.target.value)),
                  })}
                />
                <FormInputText
                  name='middleName'
                  control={control}
                  label='Middle Name'
                  //errors={!!errors.middleName}
                  //helperText={errors?.middleName?.message}
                  register={register('middleName', {
                    onChange: (e) => dispatch(setMiddleName(e.target.value)),
                  })}
                />
                <FormInputText
                  name='lastName'
                  control={control}
                  label='Last Name'
                  errors={!!errors.lastName}
                  helperText={errors?.lastName?.message}
                  register={register('lastName', {
                    onChange: (e) => dispatch(setLastName(e.target.value)),
                  })}
                />
                <FormInputText
                  name='SSN'
                  control={control}
                  label='SSN'
                  type='number'
                  minValue={0}
                  //errors={!!errors.SSN}
                  //helperText={errors?.SSN?.message}
                  register={register('SSN', {
                    onChange: (e) => dispatch(setSSN(e.target.value)),
                  })}
                />
                <FormInputText
                  name='dateOfBirth'
                  control={control}
                  label='DOB'
                  shrink={true}
                  type='date'
                  maxValue={dateString}
                  errors={!!errors.dateOfBirth}
                  helperText={errors?.dateOfBirth?.message}
                  register={register('dateOfBirth', {
                    onChange: (e) => dispatch(setDateOfBirth(e.target.value)),
                  })}
                />
                <FormInputText
                  name='suffix'
                  control={control}
                  label='Suffix'
                  //errors={!!errors.suffix}
                  //helperText={errors?.suffix?.message}
                  register={register('suffix', {
                    onChange: (e) => dispatch(setSuffix(e.target.value)),
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputDropdown
                  name='gender'
                  control={control}
                  label='Gender'
                  options={mfDropdown}
                  defaultId={defaultValue?.gender}
                  errors={!!errors.gender}
                  helperText={errors?.gender?.message}
                  register={register('gender', {
                    onChange: (e) => dispatch(setGender(e.target.value)),
                  })}
                />
                <InputDropdown
                  name='ethnicityOrRace'
                  control={control}
                  label='Ethnicity Or Race'
                  options={addParticipantReferenceData?.ethnicities}
                  defaultId={defaultValue?.ethnicityOrRace}
                  errors={!!errors.ethnicityOrRace}
                  helperText={errors?.ethnicityOrRace?.message}
                  register={register('ethnicityOrRace', {
                    onChange: (e) =>
                      dispatch(setEthnicityOrRace(e.target.value)),
                  })}
                />
                <InputDropdown
                  name='veteran'
                  control={control}
                  label='Veteran'
                  options={yesNoDropdown}
                  defaultId={defaultValue?.veteran}
                  errors={!!errors.veteran}
                  helperText={errors?.veteran?.message}
                  register={register('veteran', {
                    onChange: (e) => dispatch(setVeteran(e.target.value)),
                  })}
                />
                <InputDropdown
                  name='deployedCombatDuty'
                  control={control}
                  label='Deployed Combat Duty'
                  options={yesNoDropdown}
                  defaultId={defaultValue?.deployedCombatDuty}
                  errors={!!errors.deployedCombatDuty}
                  helperText={errors?.deployedCombatDuty?.message}
                  register={register('deployedCombatDuty', {
                    onChange: (e) =>
                      dispatch(setDeployedCombatDuty(e.target.value)),
                  })}
                />
                <InputDropdown
                  name='diagnosedPostTraumaticStressDisorder'
                  control={control}
                  label='Diagnosed Post Traumatic Stress Disorder'
                  options={yesNoDropdown}
                  defaultId={defaultValue?.diagnosedPostTraumaticStressDisorder}
                  errors={!!errors.diagnosedPostTraumaticStressDisorder}
                  helperText={
                    errors?.diagnosedPostTraumaticStressDisorder?.message
                  }
                  register={register('diagnosedPostTraumaticStressDisorder', {
                    onChange: (e) =>
                      dispatch(
                        setDiagnosedPostTraumaticStressDisorder(e.target.value)
                      ),
                  })}
                />
                <FormInputMultiCheckbox
                  control={control}
                  name='registration290'
                  label='290 Reg'
                  checked={defaultValue?.registration290}
                  register={register('registration290', {
                    onChange: (e) =>
                      dispatch(setRegistration290(e.target.value)),
                  })}
                />
                <FormInputMultiCheckbox
                  control={control}
                  name='arsonist'
                  label='Arsonist'
                  checked={defaultValue?.arsonist}
                  register={register('arsonist', {
                    onChange: (e) => dispatch(setArsonist(e.target.value)),
                  })}
                />
              </Grid>
              {getSaveCancel(handleClose, null, handleSubmit(onSubmit))}
            </Grid>
          </>
        )}
      </Dialog>
      {getFormSuccess(formSuccess, setFormSuccess, isAddParticipant)}
    </>
  );
};

export default ParticipantDialog;
